import { Injectable } from "@angular/core";
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { validateRut } from '@fdograph/rut-utilities';
@Injectable()
export class CommonService {

    setFormGroupValues(formGroup: FormGroup, values: { [key: string]: any }) {
        for (const controlName in values) {
            const control = formGroup.get(controlName) ;
            if (control && values[controlName] !== null) {
                control?.setValue(values[controlName]);
            }
        }
    }

     createRutValidator(): ValidatorFn {
        return (control:AbstractControl) : ValidationErrors | null => {
            const value = control.value;
            if (!value) {
                return null;
            }
    
            return validateRut(value) ? null : { invalidRut: true };
        }
    }
}
